<template>
  <div class="header-user" :title="userName">
    <div class="main-user-image">
      <svg class='header-icon'>
        <use xlink:href="#jdy-nologin"></use>
      </svg>
    </div>
    <ul class="jdypage-dropDown-list" :style='{display:hideVal}'>
      <li class="jdypage-dropDown-item">
        <router-link 
            active-class='current'
            to="/system/myhome#userMessage"
            @click.native='hidelist'
        >
          <svg class="icon font-icon">
            <use xlink:href="#jdy-lineUser"></use>
          </svg>
          <span>用户信息</span>
        </router-link>
      </li>
      <li class="jdypage-dropDown-item">
        <router-link 
            active-class='current'
            to="/system/myhome#resetPassword"
            @click.native='hidelist'
        >
          <svg class="icon font-icon">
            <use xlink:href="#jdy-resetpas"></use>
          </svg>
          <span>修改密码</span>
        </router-link>
      </li>
      <li class="jdypage-dropDown-item">
        <a href="javascript:;" @click="modalData.dialogVisible = true">
          <svg class="icon font-icon">
            <use xlink:href="#jdy-logout"></use>
          </svg>
          <span>注销</span>
        </a>
      </li>
    </ul>
    <modal :data='modalData'>
        <span slot='dialog-body'>您确定要登出吗？</span>
    </modal>
  </div>
</template>
<script>
  export default {
    name: "userMessage",
    data() {
      return {
        hideVal:"",
        userName: "",
        modalData:{
            dialogVisible:false,
            dialogTitle:"登出",
            dialogWidth:"30%",
            haveFooter:true,
            callback:this.signOut,
        }
      };
    },
    methods: {
        hidelist(){
            let me = this;
            let tim = ''
            me.hideVal = 'none',
            tim = setTimeout(function(){
              me.hideVal = '';
              clearTimeout(tim);
            },100)
        },
      signOut() {
          //退出
          this.$identity.signOut();
          //跳转登录页
         // window.location.href = '/login.html';
          this.$router.push("/login.html");
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/header-user.vue